import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'navy.800');
  const surfaceColor = useColorModeValue('gray.50', 'whiteAlpha.50');
  const textColor = useColorModeValue('gray.800', 'white');
  const secondaryTextColor = useColorModeValue('gray.500', 'gray.400');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const inputBackground = useColorModeValue('white', 'navy.900');
  const accentColor = useColorModeValue('blue.600', 'blue.300');
  const placeholderColor = useColorModeValue('gray.400', 'gray.500');
  const sourceBannerBg = useColorModeValue('blue.50', 'whiteAlpha.100');
  const sourceBannerBorder = useColorModeValue('blue.100', 'whiteAlpha.200');
  const codeBg = useColorModeValue('gray.100', 'whiteAlpha.100');

  return {
    backgroundCardColor,
    surfaceColor,
    textColor,
    secondaryTextColor,
    borderColor,
    inputBackground,
    accentColor,
    placeholderColor,
    sourceBannerBg,
    sourceBannerBorder,
    codeBg,
  };
};
